import React from "react";
import { Link } from "react-router-dom";
import { Layout, Icon, Menu, Button } from "antd";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { logout } from "../../redux/actions/auth";
import { selectCurrentUser } from "../../redux/selectors/auth";

const { Header } = Layout;
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_8d5l8fzk5b87iudi.js"
});

class NavigationBar extends React.Component {
  handleClick = e => {};

  render() {
    return (
      <Header style={{ minHeight: 230, padding: 0 }}>
        <Menu
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={["2"]}
          style={{
            lineHeight: "64px",
            paddingLeft: 50,
            paddingRight: 50,
            display: "flex",
            flexDirection: "row"
          }}
        >
          <Menu.Item style={{ paddingLeft: 5, paddingRight: 5 }}>
            <IconFont type="icon-facebook" />
          </Menu.Item>
          <Menu.Item style={{ paddingLeft: 5, paddingRight: 5 }}>
            <IconFont type="icon-twitter" />
          </Menu.Item>
          <Menu.Item style={{ paddingLeft: 5, paddingRight: 5 }}>
            <IconFont type="icon-facebook" />
          </Menu.Item>
          <Menu.Item style={{ paddingLeft: 5, paddingRight: 5 }}>
            <IconFont type="icon-twitter" />
          </Menu.Item>
          <Menu.Item key="30">
            <div>Preguntas Frecuentes</div>
          </Menu.Item>
          <Menu.Item key="31">
            <div>Contacto</div>
          </Menu.Item>
          <Menu.Item key="19">
            <Button onClick={() => this.props.logout()}>Logout</Button>
          </Menu.Item>
          <Menu.Item key="22" style={{ alignSelf: "flex-end" }}>
            <span>
              <span>
                Nombre:{" "}
                {this.props.user.displayName ||
                  this.props.user.nombre ||
                  this.props.user.name}
              </span>
            </span>
          </Menu.Item>
          <Menu.Item key="260" style={{ alignSelf: "flex-end" }}>
            <span>
              <span>
                Curso: {this.props.user.nivel}
                {this.props.user.identificadorNivel}
              </span>
            </span>
          </Menu.Item>
          <Menu.Item key="289" style={{ alignSelf: "flex-end" }}>
            {process.env.NODE_ENV !== "production" && (
              <code>{process.env.NODE_ENV}</code>
            )}
          </Menu.Item>
        </Menu>
        <Menu
          mode="horizontal"
          style={{
            lineHeight: "100px",
            paddingLeft: 50,
            paddingRight: 50
          }}
        >
          <Menu.Item key="5">
            <Link to="/">
              <img
                src={require("../../assets/swarmob.png")}
                alt="swarmob"
                height="100"
              />
            </Link>
          </Menu.Item>
        </Menu>
      </Header>
    );
  }
}

const mapStateToProps = state => {
  const user = selectCurrentUser(state);
  return {
    user
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({ logout }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationBar);
